import React from "react";
import { Spinner, Button, Modal } from "react-bootstrap";
import "../JobBoardExpanded.scss";
import { nameExtractor } from "../../../../_helpers/nameExtractor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlusCircle,
  faInfoCircle,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
function CandidateJobApply({
  jobDetails,
  fieldsShown,
  userInfo,
  onProfileUpdate,
  formSubmitError,
  onFormDataChange,
  formData,
  onSubmitForm,
  jobApplyLoading,
  onResumeUpload,
  editResumeClicked,
  onResumeEditClick,
  jobApplyModal,
  onApplyClick,
  isResumeLoading,
  isPrfoileUpdateLoading
}) {
  return (
    <Modal show={jobApplyModal} onHide={() => onApplyClick()}>
      <Modal.Header closeButton>
        <Modal.Title>{jobDetails?.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="rounded-lg shadow-sm border">
          <div className="job-detail">
            <div className="top bg-grey-2 py-3 px-4">
              <h3 className="font-weight-medium">Personal Details</h3>
            </div>
            <div className="bg-white px-3 pt-2">
              <div className="row">
                {/* candidate profile */}
                {/* {fieldsShown?.headline && ( */}
                  <div className="col-md-12">
                    <div className="py-1 px-0 form-group">
                      <p className="font-weight-medium">
                        <span className="text-danger"> *</span>
                        Headline
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="text"
                        placeholder="Enter Headline"
                        defaultValue={userInfo?.headline}
                        name={"headline"}
                        onBlur={onProfileUpdate}
                      />
                      {formSubmitError?.headline && (
                        <span className="text-danger mt-1">
                          {formSubmitError?.headline}
                        </span>
                      )}
                    </div>
                  </div>
                {/* )} */}

              </div>
            </div>
          </div>

          {/* details */}
          <div className="job-detail mb-3 px-3">
            <div className="row">
              {/* candidate summary here */}
              {/* {fieldsShown?.summary && ( */}
                <div className="col-md-12">
                  <div className="py-1 px-0 form-group">
                    <p className="font-weight-medium">
                      {/* {fieldsShown?.summary === "mandatory" ? (
                        <span className="text-danger"> *</span>
                      ) : null}{" "} */}
                      Summary
                    </p>
                    <input
                      className="form-control bg-transparent"
                      type="text"
                      placeholder="Enter your professional and educational summary"
                      defaultValue={formData?.summary}
                      onChange={onFormDataChange}
                      name="summary"
                    />
                    {formSubmitError?.summary && (
                      <span className="text-danger mt-1">
                        {formSubmitError?.summary}
                      </span>
                    )}
                  </div>
                </div>
              {/* )} */}

              {/* candidate cover letter here */}
              {/* {fieldsShown?.resume && ( */}
                <div className="col-md-12">
                  <p className="font-weight-medium">
                  <span className="text-danger"> *</span>Resume{" "}
                    <span
                      onClick={onResumeEditClick}
                      className="btn-remove-pic cursor-pointer  bg-grey-2 rounded-circle"
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </span>
                  </p>
                  {editResumeClicked ? (
                    <>
                      {isResumeLoading ? (
                        <Spinner animation="border" variant="primary"/>
                      ) : (
                        <input
                          className="form-control bg-transparent h-auto"
                          type="file"
                          name="resume"
                          accept=".pdf"
                          onChange={onResumeUpload}
                        />
                      )}
                    </>
                  ) : userInfo?.user_details &&
                    userInfo.user_details?.user_meta_info &&
                    userInfo.user_details.user_meta_info?.resume !== null ? (
                    <p className="form-control bg-transparent d-flex align-items-center h-auto">
                      {nameExtractor(
                        userInfo?.user_details &&
                          userInfo.user_details?.user_meta_info &&
                          userInfo.user_details.user_meta_info?.resume
                      )}
                    </p>
                  ) : (
                    <p className="form-control mw-100 mb-0 d-flex justify-content-center align-items-center h-auto">
                      <span>
                        <FontAwesomeIcon icon={faInfoCircle} className="mr-3" />
                        <span>No resume Chosen</span>
                      </span>
                      <span
                        onClick={onResumeEditClick}
                        className="ml-3 bg-light p-1 px-3 cursor-pointer rounded"
                      >
                        <FontAwesomeIcon className="mr-3" icon={faPlusCircle} />
                        Upload New
                      </span>
                    </p>
                  )}
                </div>
              {/* )} */}
            </div>
          </div>
          <Button
            variant=""
            onClick={() => onApplyClick()}
            className="btn btn-dark mx-3 mb-3"
          >
            Close
          </Button>
          {formSubmitError?.msg &&
          formSubmitError?.msg === "Already Applied" ? null : (
            <Button
              variant="primary"
              disabled={isResumeLoading|| isPrfoileUpdateLoading}
              onClick={(e) => onSubmitForm(e)}
              className="mb-3"
            >
              {jobApplyLoading ? (
                <Spinner animation="border" variant="white" />
              ) : (
                " Apply"
              )}
            </Button>
          )}
          {formSubmitError ? (
            <span className="text-danger mt-1 font-weight-bold">
              {formSubmitError.msg}
            </span>
          ) : null}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default CandidateJobApply;
